<template>
  <div>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
               action-buttons-name="ConsultasListActionButtons" filter toolbar
               toolbar-title="Consultas" search-text="Buscar por asunto de consulta">
    </DataTable>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newConsulta">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {
  components: {
    DataTable
  },

  data () {
    return {
      path: 'consulta',
      filterPath: 'filters/inquiries'
    }
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Última modificación', value: 'modified', align: 'left' },
        { text: 'Asunto', value: 'title', sortable: false, align: 'left' },
        { text: 'Departamento', value: 'department', filterField: true, align: 'left' },
        { text: 'Partido', value: 'partido' },
        { text: 'Estado', value: 'status', filterField: true, align: 'left' },
        { text: 'Detalles', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(3, 0, { text: 'Club', value: 'club', filterField: true, align: 'left' })
      }
      return headers
    },
    properties () {
      let properties = ['modified', 'title', 'departamento', 'partido.description', 'estado']
      if (this.$store.getters.isSafRole) {
        properties.splice(3, 0, 'autor.club.nombre')
      }
      return properties
    },
    canCreate () {
      return this.$store.state.permissions.canAddConsultas
    }
  },

  methods: {
    newConsulta () {
      this.$router.push({ name: 'nuevaConsulta' })
    }
  }
}
</script>
